'use strict';
const _ = require('underscore'),
	applyIdeaAttributesToNodeTheme = require('../theme/apply-idea-attributes-to-node-theme'),
	themes = require('../themes/index'),
	mergeThemesV2 = require('./merge-themes-v2'),
	themesIndex = require('../themes/index'),
	ThemeV2 = require('./theme-v2'),
	isObjectObject = require('@mindmup/js-utils/src/is-object-object'),
	deepAssign = require('../deep-assign'),
	isEmpty = require('@mindmup/js-utils/src/is-empty'),
	traverse = require('../content/traverse');
module.exports = function ThemeProvider(activeContentProvider) {
	let nodeThemeCache = {}, cachedTheme, levelCache = false, condensedCache = {};
	const self = this,
		getThemeSource = function () {
			const activeContent = activeContentProvider.getActiveContent();
			if (!activeContent) {
				return {};
			}
			return {
				themeFromRoot: activeContent.getAttr('theme'),
				overrides: activeContent.getAttr('themeOverrides')
			};
		},
		getLevel = function (ideaId) {
			if (!levelCache) {
				levelCache = {};
				const root = activeContentProvider.getActiveContent();
				traverse(root, (idea, level) => {
					levelCache[idea.id] = level;
				});
			}
			return levelCache[ideaId];
		},
		isCondensed = (node) => node.attr?.condensed,
		traverseWithForcedCondensed = function (idea, predicate, forceCondensed) {
			const shouldIncludeSubIdeas = !(isEmpty(idea.ideas) || (idea.attr?.collapsed));
			if (shouldIncludeSubIdeas) {
				Object.values(idea.ideas).forEach((subIdea) => {
					const condensed = isCondensed(idea) || forceCondensed;
					traverseWithForcedCondensed(subIdea, predicate, condensed);
				});
			}
			return predicate(idea, forceCondensed);
		},

		getCondensed = function (ideaId) {
			if (!condensedCache) {
				condensedCache = {};
				const root = activeContentProvider.getActiveContent();
				traverseWithForcedCondensed(root, (idea, forceCondensed) => {
					if (forceCondensed) {
						condensedCache[idea.id] = 'condensed-child';
					} else if (isCondensed(idea)) {
						condensedCache[idea.id] = 'condensed';
					}

					// const condensed = isCondensed(idea) || forceCondensed;
					// condensedCache[idea.id] = condensed;
				});
			}
			return condensedCache[ideaId];
		},
		initializeThemeJSONFromContent = (additionalOverrides) => {
			const themeSource = getThemeSource(),
				defaultTheme = themesIndex.default,
				selectedTheme = (isObjectObject(themeSource.themeFromRoot) ? themeSource.themeFromRoot : themes[themeSource.themeFromRoot]),
				themeOverride = deepAssign({}, themeSource.overrides || {}, additionalOverrides || {}),
				mergedThemeJson = mergeThemesV2({defaultTheme, selectedTheme, themeOverride});
			return mergedThemeJson;
		},
		buildCachedTheme = () => {
			const source = getThemeSource(),
				mergedThemeJson = initializeThemeJSONFromContent(),
				result = new ThemeV2(mergedThemeJson);
			return {
				source: source,
				mergedThemeJson: mergedThemeJson,
				result: result
			};
		},
		getCachedTheme = () => {
			if (!cachedTheme) {
				cachedTheme = buildCachedTheme();
			}
			return cachedTheme;
		},
		getTheme = function () {
			return getCachedTheme().result;
		},
		themeChanged = function () {
			if (!cachedTheme) {
				return true;
			}
			const themeSource = getThemeSource();
			return !_.isEqual(themeSource, cachedTheme.source);
		},
		invalidateCache = function () {
			nodeThemeCache = {};
			levelCache = false;
			condensedCache = false;
			if (themeChanged()) {
				cachedTheme = false;
			}
		},
		generateClassList = function (idea, theme) {
			if (!idea) {
				return ['default'];
			}
			const nodeLevel = getLevel(idea.id),
				classList = (theme?.nodeStyles && theme.nodeStyles(nodeLevel, idea.attr)) || ['default'],
				collapsed = !!(idea.attr && idea.attr.collapsed);
			if (collapsed) {
				classList.push('collapsed');
			} else {
				const condensedClass = getCondensed(idea.id);
				if (condensedClass) {
					classList.unshift(condensedClass);
				}
			}
			return classList;
		};
	activeContentProvider.addListener(invalidateCache);
	self.effectiveStylesForLevelAndAttr = (nodeLevel, attr) => {
		const theme = getTheme(),
			collapsed = !!(attr && attr.collapsed),
			classList = (theme &&  theme.nodeStyles && theme.nodeStyles(nodeLevel, attr)) || ['default'];
		if (collapsed) {
			classList.push('collapsed');
		}

		return classList;
	};
	self.getLevelForIdeaId = getLevel;
	self.getThemeJSON = (themeOverride) => {
		if (!themeOverride) {
			return getCachedTheme().mergedThemeJson;
		} else {
			return initializeThemeJSONFromContent(themeOverride);
		}

	};
	self.getTheme = getTheme;
	self.getNodeThemeForLevelAndAttr = (level, attr) => {
		const theme = getTheme(),
			nodeTheme = theme.nodeTheme(theme.nodeStyles(level, attr));
		return applyIdeaAttributesToNodeTheme({attr: attr}, nodeTheme);
	};

	self.getNodeTheme = function (ideaId) {
		if (nodeThemeCache[ideaId]) {
			return nodeThemeCache[ideaId];
		}
		const theme = getTheme(),
			idea = activeContentProvider.getActiveContent().findSubIdeaById(ideaId),
			styles = generateClassList(idea, theme),
			nodeTheme = idea && theme.nodeTheme(styles);
		if (!idea) {
			return {};
		}
		nodeThemeCache[ideaId] = applyIdeaAttributesToNodeTheme(idea, nodeTheme);
		nodeThemeCache[ideaId].effectiveStyles = styles;
		return nodeThemeCache[ideaId];
	};

};
